var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ready
        ? _c(
            "div",
            [
              _vm._t("top"),
              !_vm.accountModal && this.form.id
                ? _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "negative",
                      label: "delete record",
                      icon: "delete"
                    },
                    on: { click: _vm.handleDeleteRecord }
                  })
                : _vm._e(),
              !_vm.accountModal
                ? _c("div", { staticClass: "block q-pa-sm" })
                : _vm._e(),
              !_vm.accountModal
                ? _c("div", { staticClass: "block full-width" }, [_vm._m(0)])
                : _vm._e(),
              _c("div", { staticClass: "mdi-card full-width q-pa-md" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Email",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Email / Username",
                            inset: "full",
                            icon: _vm.errors.has("Email", _vm.validatorFormName)
                              ? "star_border"
                              : "star",
                            "icon-color": _vm.errors.has(
                              "Email",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : "blue-5",
                            error: _vm.errors.has(
                              "Email",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Email",
                              _vm.validatorFormName
                            ),
                            helper:
                              "Username is: " +
                              _vm.oldUsername +
                              " - if this does not match the email.  It will after save."
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email|uniqueusername",
                                expression: "'required|email|uniqueusername'"
                              }
                            ],
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Email",
                              type: "email",
                              name: "email",
                              "hide-underline": "",
                              "inverted-light": "",
                              color: _vm.errors.has("Email")
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Role",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Role",
                            inset: "full",
                            icon: _vm.errors.has("Role", _vm.validatorFormName)
                              ? "star_border"
                              : "star",
                            "icon-color": _vm.errors.has(
                              "Role",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : "blue-5",
                            error: _vm.errors.has(
                              "Role",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Role",
                              _vm.validatorFormName
                            )
                          }
                        },
                        [
                          _c("q-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Role",
                              name: "roleId",
                              "hide-underline": "",
                              "inverted-light": "",
                              options: _vm.roleSelections,
                              color: _vm.errors.has("Role")
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName
                            },
                            model: {
                              value: _vm.form.roleId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "roleId", $$v)
                              },
                              expression: "form.roleId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Password",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Password",
                            inset: "full",
                            icon: "edit",
                            "icon-color": _vm.errors.has(
                              "Password",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : _vm.inputBgColor,
                            error: _vm.errors.has(
                              "Username",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Password",
                              _vm.validatorFormName
                            ),
                            helper: _vm.errors.first(
                              "Password",
                              _vm.validatorFormName
                            )
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "min:6",
                                expression: "'min:6'"
                              }
                            ],
                            ref: "password",
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Password",
                              type: "password",
                              name: "password",
                              "hide-underline": "",
                              "inverted-light": "",
                              color: _vm.errors.has(
                                "Password",
                                _vm.validatorFormName
                              )
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Password Confirmation",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Password Confirmation",
                            inset: "full",
                            icon: "edit",
                            "icon-color": _vm.errors.has(
                              "Password Confirmation",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : _vm.inputBgColor,
                            error: _vm.errors.has(
                              "Password Confirmation",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Password Confirmation",
                              _vm.validatorFormName
                            )
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.form.password
                                  ? "required|confirmed:password"
                                  : "",
                                expression:
                                  "form.password ? 'required|confirmed:password' : ''"
                              }
                            ],
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Password Confirmation",
                              type: "password",
                              name: "passwordConfirmation",
                              "hide-underline": "",
                              "inverted-light": "",
                              color: _vm.errors.has("Password Confirmation")
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName,
                              "data-vv-as": "password"
                            },
                            model: {
                              value: _vm.passwordConfirmation,
                              callback: function($$v) {
                                _vm.passwordConfirmation = $$v
                              },
                              expression: "passwordConfirmation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                !_vm.accountModal
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                        },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "q-pa-md",
                              attrs: {
                                orientation: "vertical",
                                label: "Lock User Out / Prevent Login",
                                inset: "full",
                                icon: "edit",
                                "icon-color": _vm.inputBgColor
                              }
                            },
                            [
                              _c("q-checkbox", {
                                attrs: { name: "Lockout" },
                                model: {
                                  value: _vm.lockout,
                                  callback: function($$v) {
                                    _vm.lockout = $$v
                                  },
                                  expression: "lockout"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
                        },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "q-pa-md",
                              attrs: {
                                orientation: "vertical",
                                label: "Failed Logins",
                                inset: "full"
                              }
                            },
                            [_vm._v(_vm._s(_vm.form.accessFailedCount))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
                        },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "q-pa-md",
                              attrs: {
                                orientation: "vertical",
                                label: "Last Logged In",
                                inset: "full"
                              }
                            },
                            [_vm._v(_vm._s(_vm.form.lastLoginDate))]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]),
              _vm.editingDisabled
                ? _c(
                    "div",
                    [
                      _vm.editingDisabled
                        ? _c(
                            "q-alert",
                            {
                              staticClass: "q-mb-md",
                              attrs: { type: "warning", icon: "warning" }
                            },
                            [
                              _vm._v(
                                "This record has been deleted / archived. You may not make edits to this record until it has been restore."
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "q-btn",
                        {
                          staticClass: "full-width",
                          attrs: {
                            color: "negative",
                            push: "",
                            size: "lg",
                            disabled: false
                          },
                          on: { click: _vm.apiRestoreRecord }
                        },
                        [_vm._v("Restore")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            push: "",
                            size: "lg",
                            disabled: false
                          },
                          on: { click: _vm.submit }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  ),
              !_vm.accountModal
                ? _c(
                    "div",
                    { attrs: { name: "goback" } },
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "q-mt-lg",
                          attrs: {
                            flat: "",
                            to: "/user/list",
                            color: "negative",
                            full: ""
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm.loading ? _c("q-inner-loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-between" }, [
      _c("div", { staticClass: "col-md-10" }, [
        _c(
          "h5",
          { staticClass: "text-grey-6 uppercase no-margin q-headline q-pb-sm" },
          [_vm._v("User Info")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }